<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-8">
        <lib-page-header page-title="USUÁRIOS" page-subtitle="EXERCÍCIO: {{login.exercicio.ano}}"
          image-title="assets/img/team.png">
        </lib-page-header>
      </div>
      <div class="col-md-4">
        <button type="button" (click)="sair()" class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </button>
        <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
        <button data-toggle="modal" data-target="#dialogAcesso"
          class="btn btn-sm btn-outline-secondary float-right mr-2">
          <img src="assets/img/global/lock_go.png" alt="Acessos" title="Acessos" height="20" width="20">
        </button>
      </div>
    </div>
    <hr class="mt-1 mb-4" />
    <div class="row">
      <div class="col-md-5">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length === 0">
      <div class="col-12">
        <i class="fa fa-exclamation-triangle text-black-50" style="font-size: 20px"></i>
        <span class="text-black-50 ml-1">Não foram encontrados registros cadastrados!</span>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length > 0">
      <div class="col-12 table-responsive">
        <table class="table table-eddy">
          <thead>
            <tr>
              <th scope="col" class="text-center">Cód.</th>
              <th scope="col">Nome</th>
              <th scope="col">E-mail</th>
              <th scope="col">CPF</th>
              <th scope="col">Telefone</th>
              <th scope="col">Sistema</th>
              <th scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of lista">
              <td class="text-center">{{item.id}}</td>
              <td>{{item.nome}} {{item.sobrenome}}
                <span class="d-block small text-muted">{{item.favorecido?.nome}}</span>
              </td>
              <td>{{item.email}}</td>
              <td>{{item.cpf | CPF}}</td>
              <td>{{item.telefone | TELEFONE}}</td>
              <td>{{globalService.traduzirSistema(item.sistema)}}</td>
              <td>
                <span *ngIf="item.ativo && !item.administrador && !item.solicitacao && !item.convidado"
                  class="badge badge-success">Ativo</span>
                <span *ngIf="item.ativo && !item.administrador && !item.solicitacao && item.convidado"
                  class="badge badge-secondary">Convidado</span>
                <span *ngIf="item.ativo && item.administrador" class="badge badge-primary">Administrador</span>
                <span *ngIf="!item.ativo && item.solicitacao" class="badge badge-warning">Pendente</span>
                <span *ngIf="!item.ativo && !item.solicitacao" class="badge badge-danger">Inativo</span>
              </td>
              <td class="text-right">
                <button *ngIf="podeIncluir()" [routerLink]="['/usuarios', item.id, 'editar']"
                  class="btn btn-sm btn-outline-secondary mr-2">
                  <img src="assets/img/global/zoom.png" alt="editar" height="18" width="18">
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row float-right" *ngIf="lista && lista.length > 0">
      <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
  </div>
</div>

<lib-usuario-acesso></lib-usuario-acesso>